import axios from '@/utils/axios'
import { Message } from 'element-ui';
// http response 拦截器
let instance = axios.interceptors;
instance.response.use(
    response => {
        //拦截响应，做统一处理 
        if (response.data.ResultCode) {
            switch (response.data.ResultCode) {
                case '401':
                    break;
                case '1':
                    break;
                default:
                    Message(response.data.ResultMessage);
                    break;
            }
        }
        return response
    },
    //接口错误状态处理，也就是说无响应时的处理
    error => {
        return Promise.reject(error) // 返回接口返回的错误信息
    })
const api_all = {
    //登录
    get_login(params) {
        return axios({
            url: '/api/system/account/login',
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            data: params

        })
    },
    // 退出登录
    get_logout() {
        return axios({
            url: '/api/system/account/logout',
            method: 'GET',
            params: {},
        })
    },
    // /api/system/account/info
    get_userinfo() {
        return axios({
            url: '/api/system/account/info',
            method: 'GET',
            params: {},
        })
    },
    // 涵洞信息列表
    post_culvertList(params) {
        return axios({
            url: '/api/culvert/card/page',
            method: 'POST',
            data: params

        })
    },
    post_delCulvert(params) {
        return axios({
            url: '/api/culvert/card/delete',
            headers: { 'accept': 'text/plain', 'Content-Type': 'application/json;charset=utf-8' },
            method: 'POST',
            data: JSON.stringify(params)

        })
    },
};
export default api_all


//////////////////
// WEBPACK FOOTER
// ./api/api.js
// module id = null
// module chunks = 